var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("page-step-layout", {
        scopedSlots: _vm._u(
          [
            {
              key: "title",
              fn: function () {
                return [
                  _vm._v(
                    " " + _vm._s(_vm.$t("global.doorr.subjectProperty")) + " "
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "content",
              fn: function () {
                return [
                  _vm.propertyAddressVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t("application-form.property-address")
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator("propertyAddress.required")
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("address-field-group", {
                                    ref: "addressFieldComponent",
                                    attrs: {
                                      line1: _vm.propertyAddress.line1,
                                      line2: _vm.propertyAddress.line2,
                                      "unit-number":
                                        _vm.propertyAddress["unit-number"],
                                      province: _vm.propertyAddress.province,
                                      city: _vm.propertyAddress.city,
                                      "postal-code":
                                        _vm.propertyAddress["postal-code"],
                                      "street-direction":
                                        _vm.propertyAddress["street-direction"],
                                      "street-name":
                                        _vm.propertyAddress["street-name"],
                                      "street-number":
                                        _vm.propertyAddress["street-number"],
                                      "street-type":
                                        _vm.propertyAddress["street-type"],
                                      validator:
                                        _vm.getValidator("propertyAddress"),
                                      label: "label",
                                      "hidden-label": "",
                                      "show-required-indicator": "",
                                    },
                                    on: {
                                      "update:line1": function ($event) {
                                        return _vm.$set(
                                          _vm.propertyAddress,
                                          "line1",
                                          $event
                                        )
                                      },
                                      "update:line2": function ($event) {
                                        return _vm.$set(
                                          _vm.propertyAddress,
                                          "line2",
                                          $event
                                        )
                                      },
                                      "update:unitNumber": function ($event) {
                                        return _vm.$set(
                                          _vm.propertyAddress,
                                          "unit-number",
                                          $event
                                        )
                                      },
                                      "update:unit-number": function ($event) {
                                        return _vm.$set(
                                          _vm.propertyAddress,
                                          "unit-number",
                                          $event
                                        )
                                      },
                                      "update:province": function ($event) {
                                        return _vm.$set(
                                          _vm.propertyAddress,
                                          "province",
                                          $event
                                        )
                                      },
                                      "update:city": function ($event) {
                                        return _vm.$set(
                                          _vm.propertyAddress,
                                          "city",
                                          $event
                                        )
                                      },
                                      "update:postalCode": function ($event) {
                                        return _vm.$set(
                                          _vm.propertyAddress,
                                          "postal-code",
                                          $event
                                        )
                                      },
                                      "update:postal-code": function ($event) {
                                        return _vm.$set(
                                          _vm.propertyAddress,
                                          "postal-code",
                                          $event
                                        )
                                      },
                                      "update:streetDirection": function (
                                        $event
                                      ) {
                                        return _vm.$set(
                                          _vm.propertyAddress,
                                          "street-direction",
                                          $event
                                        )
                                      },
                                      "update:street-direction": function (
                                        $event
                                      ) {
                                        return _vm.$set(
                                          _vm.propertyAddress,
                                          "street-direction",
                                          $event
                                        )
                                      },
                                      "update:streetName": function ($event) {
                                        return _vm.$set(
                                          _vm.propertyAddress,
                                          "street-name",
                                          $event
                                        )
                                      },
                                      "update:street-name": function ($event) {
                                        return _vm.$set(
                                          _vm.propertyAddress,
                                          "street-name",
                                          $event
                                        )
                                      },
                                      "update:streetNumber": function ($event) {
                                        return _vm.$set(
                                          _vm.propertyAddress,
                                          "street-number",
                                          $event
                                        )
                                      },
                                      "update:street-number": function (
                                        $event
                                      ) {
                                        return _vm.$set(
                                          _vm.propertyAddress,
                                          "street-number",
                                          $event
                                        )
                                      },
                                      "update:streetType": function ($event) {
                                        return _vm.$set(
                                          _vm.propertyAddress,
                                          "street-type",
                                          $event
                                        )
                                      },
                                      "update:street-type": function ($event) {
                                        return _vm.$set(
                                          _vm.propertyAddress,
                                          "street-type",
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyDetailsPurchaseDateVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.isPurchaseSelected
                                      ? _vm.$t("application-form.purchase-date")
                                      : _vm.$t(
                                          "application-standalone.questions.subjectProperty.purchaseDate"
                                        )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator(
                                "propertyDetailsPurchaseDate.required"
                              )
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("date-field", {
                                    attrs: {
                                      value: _vm.propertyDetailsPurchaseDate,
                                      placeholder: _vm.$t(
                                        "application-form.purchase-date"
                                      ),
                                      validator: _vm.getValidator(
                                        "propertyDetailsPurchaseDate"
                                      ),
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyDetailsPurchaseDate = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyDetailsLivingSpaceVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.subjectProperty.livingSpace"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator(
                                "propertyDetailsLivingSpace.required"
                              )
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("text-field", {
                                    attrs: {
                                      value: _vm.propertyDetailsLivingSpace,
                                      placeholder: _vm.$t(
                                        "application-standalone.questions.subjectProperty.livingSpace"
                                      ),
                                      "mask-type": "number",
                                      validator: _vm.getValidator(
                                        "propertyDetailsLivingSpace"
                                      ),
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyDetailsLivingSpace = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyStylePropertyStyleVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.subjectProperty.propertyStyle"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator(
                                "propertyStylePropertyStyle.required"
                              )
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("select-field", {
                                    attrs: {
                                      value: _vm.propertyStylePropertyStyle,
                                      options: _vm.propertyStyleOptions,
                                      placeholder: _vm.$t(
                                        "application-form.property-style"
                                      ),
                                      validator: _vm.getValidator(
                                        "propertyStylePropertyStyle"
                                      ),
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyStylePropertyStyle = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyStylePropertyTypeVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.subjectProperty.propertyType"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator(
                                "propertyStylePropertyType.required"
                              )
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("select-field", {
                                    attrs: {
                                      value: _vm.propertyStylePropertyType,
                                      options: _vm.propertyTypeOptions,
                                      validator: _vm.getValidator(
                                        "propertyStylePropertyType"
                                      ),
                                      placeholder: _vm.$t(
                                        "application-form.property-type"
                                      ),
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyStylePropertyType = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyStyleGarageSizeVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.subjectProperty.garageSize"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator(
                                "propertyStyleGarageSize.required"
                              )
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("select-field", {
                                    attrs: {
                                      value: _vm.propertyStyleGarageSize,
                                      options: _vm.propertyGarageSizeOptions,
                                      placeholder: _vm.$t(
                                        "application-form.garage-size"
                                      ),
                                      validator: _vm.getValidator(
                                        "propertyStyleGarageSize"
                                      ),
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyStyleGarageSize = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyStyleGarageStyleVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.subjectProperty.garageStyle"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator(
                                "propertyStyleGarageStyle.required"
                              )
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("select-field", {
                                    attrs: {
                                      value: _vm.propertyStyleGarageStyle,
                                      options: _vm.propertyGarageStyleOptions,
                                      placeholder: _vm.$t(
                                        "application-form.garage-style"
                                      ),
                                      validator: _vm.getValidator(
                                        "propertyStyleGarageStyle"
                                      ),
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyStyleGarageStyle = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyStyleConstructionTypeVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.subjectProperty.constructionType"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator(
                                "propertyStyleConstructionType.required"
                              )
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("radio-field", {
                                    attrs: {
                                      value: _vm.propertyStyleConstructionType,
                                      options:
                                        _vm.propertyConstructionTypeOptions,
                                      validator: _vm.getValidator(
                                        "propertyStyleConstructionType"
                                      ),
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyStyleConstructionType =
                                          $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyStyleStructureAgeVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.subjectProperty.structureAge"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator(
                                "propertyStyleStructureAge.required"
                              )
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("text-field", {
                                    attrs: {
                                      placeholder: "1",
                                      value: _vm.propertyStyleStructureAge,
                                      validator: _vm.getValidator(
                                        "propertyStyleStructureAge"
                                      ),
                                      "mask-type": "number",
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyStyleStructureAge = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyStyleNumberOfUnitsVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.subjectProperty.numberOfUnits"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator(
                                "propertyStyleNumberOfUnits.required"
                              )
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("text-field", {
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "application-form.number-of-units"
                                      ),
                                      value: _vm.propertyStyleNumberOfUnits,
                                      validator: _vm.getValidator(
                                        "propertyStyleNumberOfUnits"
                                      ),
                                      "mask-type": "integer",
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyStyleNumberOfUnits = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyStyleTenureVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.subjectProperty.tenure"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator("propertyStyleTenure.required")
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("radio-field", {
                                    attrs: {
                                      options: _vm.propertyTenureOptions,
                                      value: _vm.propertyStyleTenure,
                                      validator: _vm.getValidator(
                                        "propertyStyleTenure"
                                      ),
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyStyleTenure = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyStyleLotSizeVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.subjectProperty.lotSize"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator("propertyStyleLotSize.required")
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("text-field", {
                                    attrs: {
                                      value: _vm.propertyStyleLotSize,
                                      placeholder: _vm.$t(
                                        "application-form.lot-size"
                                      ),
                                      validator: _vm.getValidator(
                                        "propertyStyleLotSize"
                                      ),
                                      "mask-type": "number",
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyStyleLotSize = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyStyleLotSizeTypeVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.subjectProperty.lotSizeType"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator(
                                "propertyStyleLotSizeType.required"
                              )
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("select-field", {
                                    attrs: {
                                      value: _vm.propertyStyleLotSizeType,
                                      options:
                                        _vm.propertyUnitOfMeasurementOptions,
                                      placeholder: _vm.$t(
                                        "application-form.unit-of-measurement"
                                      ),
                                      validator: _vm.getValidator(
                                        "propertyStyleLotSizeType"
                                      ),
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyStyleLotSizeType = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyStyleHeatVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.subjectProperty.heat"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator("propertyStyleHeat.required")
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("select-field", {
                                    attrs: {
                                      value: _vm.propertyStyleHeat,
                                      options: _vm.propertyHeatingTypeOptions,
                                      placeholder: _vm.$t(
                                        "application-form.heating-type"
                                      ),
                                      validator:
                                        _vm.getValidator("propertyStyleHeat"),
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyStyleHeat = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyStyleWaterInfoVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.subjectProperty.waterInfo"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator(
                                "propertyStyleWaterInfo.required"
                              )
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("radio-field", {
                                    attrs: {
                                      value: _vm.propertyStyleWaterInfo,
                                      options: _vm.propertyWaterInfoOptions,
                                      validator: _vm.getValidator(
                                        "propertyStyleWaterInfo"
                                      ),
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyStyleWaterInfo = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyStyleEnvironmentalHazardVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.subjectProperty.environmentalHazard"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator(
                                "propertyStyleEnvironmentalHazard.required"
                              )
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("radio-field", {
                                    attrs: {
                                      value:
                                        _vm.propertyStyleEnvironmentalHazard,
                                      options: _vm.yesNoOptions,
                                      validator: _vm.getValidator(
                                        "propertyStyleEnvironmentalHazard"
                                      ),
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyStyleEnvironmentalHazard =
                                          $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyStyleSewageInfoVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.subjectProperty.sewageInfo"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator(
                                "propertyStyleSewageInfo.required"
                              )
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("select-field", {
                                    attrs: {
                                      value: _vm.propertyStyleSewageInfo,
                                      options: _vm.propertySewageTypeOptions,
                                      placeholder: _vm.$t(
                                        "application-form.sewage-type"
                                      ),
                                      validator: _vm.getValidator(
                                        "propertyStyleSewageInfo"
                                      ),
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyStyleSewageInfo = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyCostsPropertyTaxesVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-form.annual-property-taxes"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator(
                                "propertyCostsPropertyTaxes.required"
                              )
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("currency-field", {
                                    attrs: {
                                      value: _vm.propertyCostsPropertyTaxes,
                                      placeholder: _vm.$t(
                                        "application-form.annual-property-taxes"
                                      ),
                                      validator: _vm.getValidator(
                                        "propertyCostsPropertyTaxes"
                                      ),
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyCostsPropertyTaxes = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyCostsTaxYearVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.labels.mostRecentTaxYear"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator("propertyCostsTaxYear.required")
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("text-field", {
                                    attrs: {
                                      value: _vm.propertyCostsTaxYear,
                                      placeholder: "2021",
                                      validator: _vm.getValidator(
                                        "propertyCostsTaxYear"
                                      ),
                                      "mask-type": "number",
                                      "max-length": 4,
                                      "on-type": "",
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyCostsTaxYear = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyCostsTaxResponsibleVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.labels.propertyTaxResponsibility"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator(
                                "propertyCostsTaxResponsible.required"
                              )
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("radio-field", {
                                    attrs: {
                                      value: _vm.propertyCostsTaxResponsible,
                                      options:
                                        _vm.propertyTaxResponsibleOptions,
                                      validator: _vm.getValidator(
                                        "propertyCostsTaxResponsible"
                                      ),
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyCostsTaxResponsible = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyCostsRentalIncomeOptionsVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.labels.rentalIncomeOffset"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator(
                                "propertyCostsRentalIncomeOptions.required"
                              )
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("select-field", {
                                    attrs: {
                                      value:
                                        _vm.propertyCostsRentalIncomeOptions,
                                      options:
                                        _vm.propertyRentalIncomeSelectOptions,
                                      placeholder: _vm.$t(
                                        "application-standalone.labels.rentalIncomeOffset"
                                      ),
                                      validator: _vm.getValidator(
                                        "propertyCostsRentalIncomeOptions"
                                      ),
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyCostsRentalIncomeOptions =
                                          $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyCostsRentalIncomeOptionsPercentVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.labels.rentalIncomeOffsetPercent"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator(
                                "propertyCostsRentalIncomeOptionsPercent.required"
                              )
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("percentage-field", {
                                    attrs: {
                                      value:
                                        _vm.propertyCostsRentalIncomeOptionsPercent,
                                      placeholder: "0",
                                      validator: _vm.getValidator(
                                        "propertyCostsRentalIncomeOptionsPercent"
                                      ),
                                      "no-decimals": "",
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyCostsRentalIncomeOptionsPercent =
                                          $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyCostsPercOfTotalMaintFeesVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.labels.condoFeeAllocationPercentage"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator(
                                "propertyCostsPercOfTotalMaintFees.required"
                              )
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("percentage-field", {
                                    attrs: {
                                      value:
                                        _vm.propertyCostsPercOfTotalMaintFees,
                                      placeholder: "0",
                                      validator: _vm.getValidator(
                                        "propertyCostsPercOfTotalMaintFees"
                                      ),
                                      "no-decimals": "",
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyCostsPercOfTotalMaintFees =
                                          $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyCostsMaintenanceFeesVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.subjectProperty.maintenanceFees"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator(
                                "propertyCostsMaintenanceFees.required"
                              )
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("currency-field", {
                                    attrs: {
                                      "extra-validation": _vm.extraValidation,
                                      value: _vm.propertyCostsMaintenanceFees,
                                      placeholder: _vm.$t(
                                        "application-form.maintenance-fees-monthly"
                                      ),
                                      validator: _vm.getValidator(
                                        "propertyCostsMaintenanceFees"
                                      ),
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyCostsMaintenanceFees =
                                          $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyCostsFeesIncludeHeatVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.feesIncludeHeat"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator(
                                "propertyCostsFeesIncludeHeat.required"
                              )
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("radio-field", {
                                    attrs: {
                                      value: _vm.propertyCostsFeesIncludeHeat,
                                      options: _vm.yesNoOptions,
                                      validator: _vm.getValidator(
                                        "propertyCostsFeesIncludeHeat"
                                      ),
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyCostsFeesIncludeHeat =
                                          $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyCostsHeatingVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.labels.heatFees"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator("propertyCostsHeating.required")
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("currency-field", {
                                    attrs: {
                                      "extra-validation": _vm.extraValidation,
                                      value: _vm.propertyCostsHeating,
                                      placeholder: _vm.$t(
                                        "application-standalone.labels.heatFees"
                                      ),
                                      validator: _vm.getValidator(
                                        "propertyCostsHeating"
                                      ),
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyCostsHeating = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyCostsHydroVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.labels.hydroFees"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator("propertyCostsHydro.required")
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("currency-field", {
                                    attrs: {
                                      "extra-validation": _vm.extraValidation,
                                      value: _vm.propertyCostsHydro,
                                      placeholder: _vm.$t(
                                        "application-standalone.labels.hydroFees"
                                      ),
                                      validator:
                                        _vm.getValidator("propertyCostsHydro"),
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyCostsHydro = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyCostsInsuranceVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.labels.insuranceFees"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator(
                                "propertyCostsInsurance.required"
                              )
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("currency-field", {
                                    attrs: {
                                      "extra-validation": _vm.extraValidation,
                                      value: _vm.propertyCostsInsurance,
                                      placeholder: _vm.$t(
                                        "application-standalone.labels.insuranceFees"
                                      ),
                                      validator: _vm.getValidator(
                                        "propertyCostsInsurance"
                                      ),
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyCostsInsurance = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyCostsManagementVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.labels.managementFees"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator(
                                "propertyCostsManagement.required"
                              )
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("currency-field", {
                                    attrs: {
                                      "extra-validation": _vm.extraValidation,
                                      value: _vm.propertyCostsManagement,
                                      placeholder: _vm.$t(
                                        "application-standalone.labels.managementFees"
                                      ),
                                      validator: _vm.getValidator(
                                        "propertyCostsManagement"
                                      ),
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyCostsManagement = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyCostsRepairsVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.labels.repairs"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator("propertyCostsRepairs.required")
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("currency-field", {
                                    attrs: {
                                      "extra-validation": _vm.extraValidation,
                                      value: _vm.propertyCostsRepairs,
                                      placeholder: _vm.$t(
                                        "application-standalone.labels.repairs"
                                      ),
                                      validator: _vm.getValidator(
                                        "propertyCostsRepairs"
                                      ),
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyCostsRepairs = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyCostsInterestVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.labels.interestFees"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator("propertyCostsInterest.required")
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("currency-field", {
                                    attrs: {
                                      "extra-validation": _vm.extraValidation,
                                      value: _vm.propertyCostsInterest,
                                      placeholder: _vm.$t(
                                        "application-standalone.labels.interestFees"
                                      ),
                                      validator: _vm.getValidator(
                                        "propertyCostsInterest"
                                      ),
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyCostsInterest = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyCostsOthersVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.labels.otherFees"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator("propertyCostsOthers.required")
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("currency-field", {
                                    attrs: {
                                      "extra-validation": _vm.extraValidation,
                                      value: _vm.propertyCostsOthers,
                                      placeholder: _vm.$t(
                                        "application-standalone.labels.otherFees"
                                      ),
                                      validator: _vm.getValidator(
                                        "propertyCostsOthers"
                                      ),
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyCostsOthers = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyDetailsOccupancyVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.occupancyType"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator(
                                "propertyDetailsOccupancy.required"
                              )
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("select-field", {
                                    attrs: {
                                      value: _vm.propertyDetailsOccupancy,
                                      options:
                                        _vm.propertyDetailsOccupancyOptions,
                                      placeholder: _vm.$t(
                                        "application-form.property-occupancy-type"
                                      ),
                                      validator: _vm.getValidator(
                                        "propertyDetailsOccupancy"
                                      ),
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyDetailsOccupancy = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyDetailsRentalPropertyVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.subjectProperty.rentalProperty"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator(
                                "propertyDetailsRentalProperty.required"
                              )
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("radio-field", {
                                    attrs: {
                                      value: _vm.propertyDetailsRentalProperty,
                                      options: _vm.yesNoOptions,
                                      placeholder: _vm.$t(
                                        "application-form.is-income-property"
                                      ),
                                      validator: _vm.getValidator(
                                        "propertyDetailsRentalProperty"
                                      ),
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyDetailsRentalProperty =
                                          $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyDetailsMonthlyIncomeVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.monthlyIncome"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator(
                                "propertyDetailsMonthlyIncome.required"
                              )
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("currency-field", {
                                    attrs: {
                                      "extra-validation": _vm.extraValidation,
                                      value: _vm.propertyDetailsMonthlyIncome,
                                      placeholder: _vm.$t(
                                        "application-form.monthly-income"
                                      ),
                                      validator: _vm.getValidator(
                                        "propertyDetailsMonthlyIncome"
                                      ),
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyDetailsMonthlyIncome =
                                          $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyDetailsMlsListingVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.subjectProperty.mlsListing"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator(
                                "propertyDetailsMlsListing.required"
                              )
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("radio-field", {
                                    attrs: {
                                      value: _vm.propertyDetailsMlsListing,
                                      options: _vm.yesNoOptions,
                                      validator: _vm.getValidator(
                                        "propertyDetailsMlsListing"
                                      ),
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyDetailsMlsListing = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyDetailsLotVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.subjectProperty.lot"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator("propertyDetailsLot.required")
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("text-field", {
                                    attrs: {
                                      value: _vm.propertyDetailsLot,
                                      placeholder: "132E",
                                      validator:
                                        _vm.getValidator("propertyDetailsLot"),
                                      "max-length": 35,
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyDetailsLot = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyDetailsBlockVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.subjectProperty.block"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator("propertyDetailsBlock.required")
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("text-field", {
                                    attrs: {
                                      value: _vm.propertyDetailsBlock,
                                      placeholder: "Block A",
                                      validator: _vm.getValidator(
                                        "propertyDetailsBlock"
                                      ),
                                      "max-length": 35,
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyDetailsBlock = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyDetailsConcTownshipVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.labels.township"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator(
                                "propertyDetailsConcTownship.required"
                              )
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("text-field", {
                                    attrs: {
                                      value: _vm.propertyDetailsConcTownship,
                                      placeholder: "King City",
                                      validator: _vm.getValidator(
                                        "propertyDetailsConcTownship"
                                      ),
                                      "max-length": 35,
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyDetailsConcTownship = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyDetailsEstimatedValueVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.estimatedValue"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator(
                                "propertyDetailsEstimatedValue.required"
                              )
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("currency-field", {
                                    attrs: {
                                      value: _vm.propertyDetailsEstimatedValue,
                                      placeholder: _vm.$t(
                                        "application-standalone.questions.estimatedValue"
                                      ),
                                      validator: _vm.getValidator(
                                        "propertyDetailsEstimatedValue"
                                      ),
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyDetailsEstimatedValue =
                                          $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyDetailsAppraisedValueVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.subjectProperty.appraisedValue"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator(
                                "propertyDetailsAppraisedValue.required"
                              )
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("currency-field", {
                                    attrs: {
                                      value: _vm.propertyDetailsAppraisedValue,
                                      placeholder: _vm.$t(
                                        "application-standalone.questions.subjectProperty.appraisedValue"
                                      ),
                                      validator: _vm.getValidator(
                                        "propertyDetailsAppraisedValue"
                                      ),
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyDetailsAppraisedValue =
                                          $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.propertyDetailsAppraisalDateVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.subjectProperty.appraisedDate"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator(
                                "propertyDetailsAppraisalDate.required"
                              )
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("date-field", {
                                    attrs: {
                                      value: _vm.propertyDetailsAppraisalDate,
                                      placeholder: _vm.$t(
                                        "application-form.appraisal-date"
                                      ),
                                      validator: _vm.getValidator(
                                        "propertyDetailsAppraisalDate"
                                      ),
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.propertyDetailsAppraisalDate =
                                          $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showSubjectPropertyExistingMortgages &&
                  _vm.existingMortgagesIsVisible
                    ? _c(
                        "page-section-group-layout",
                        [
                          _c("section-title", [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t(
                                    "application-standalone.questions.subjectProperty.existingMortgages"
                                  )
                                ) +
                                "\n        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("radio-field", {
                            attrs: {
                              value: _vm.propertyHasExistingMortgages,
                              options: _vm.yesNoOptions,
                            },
                            on: {
                              change:
                                _vm.handleChangeIsThePropertyStillMortgaged,
                            },
                          }),
                          _vm._v(" "),
                          _vm.propertyHasExistingMortgages
                            ? _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "12" } },
                                    [
                                      _vm._l(
                                        _vm.subjectProperty[
                                          "existing-mortgages"
                                        ],
                                        function (
                                          existingMortgage,
                                          existingMortgageIndex
                                        ) {
                                          return _c(
                                            "subject-property-existing-mortgage",
                                            {
                                              key:
                                                existingMortgage["lender"] +
                                                "-" +
                                                existingMortgageIndex,
                                              ref: "",
                                              refInFor: true,
                                              attrs: {
                                                "existing-mortgage-index":
                                                  existingMortgageIndex,
                                              },
                                            }
                                          )
                                        }
                                      ),
                                      _vm._v(" "),
                                      _vm.existingMortgagesIsVisible
                                        ? _c(
                                            "button",
                                            {
                                              staticClass: "btn btn-primary",
                                              on: {
                                                click: _vm.addExistingMortgage,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "application-standalone.pages.properties.addAnotherExistingMortgage"
                                                    )
                                                  ) +
                                                  "\n            "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            {
              key: "navigation",
              fn: function () {
                return [
                  _vm._t("navigation-toolbar", null, null, {
                    handleNavigateNext: _vm.handleNavigateNext,
                    handleNavigateBack: _vm.handleNavigateBack,
                  }),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }